import React from 'react';
import PropTypes from "prop-types";
import { Header, Segment } from 'semantic-ui-react'


import './Banner.css';

const Banner = ({ copy }) => {
  return (
    <Segment inverted color='teal' basic padded='very' vertical textAlign='center' className="homepagePane">
      <Header id='jumboText' color='blue'>{copy.header}</Header>
      <p className="subtitle">{copy.subheader}</p>
    </Segment>
  );
};

Banner.propTypes = {
  copy: PropTypes.object.isRequired
}

export default Banner;


// WEBPACK FOOTER //
// ./src/Homepage/Banner.js